import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import Header from '../general/Header';
import Aside from '../general/Aside';
import Footer from '../general/Footer';
import Loading from '../general/Loading';
import ModalRipsExito from './ModalRipsExito';
import Unauthorized from '../general/Unauthorized';

function ListadoRips() {
    const [rips, setRips] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasPermission, setHasPermission] = useState(null);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [filtroTipo, setFiltroTipo] = useState('');

    const [showModalInfo, setShowModalInfo] = useState(false);
    const [ripsSeleccionado, setRipsSeleccionado] = useState(null);

    useEffect(() => {
        let userdata = {};
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some((p) => p.slug === 'administrarRips');
        } else if (userdata.up && userdata.up.includes('administrarRips')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);

        const hoy = new Date();
        const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        const ultimoDia = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);

        setFechaInicio(primerDia.toISOString().split('T')[0]);
        setFechaFin(ultimoDia.toISOString().split('T')[0]);
    }, []);

    useEffect(() => {
        if (fechaInicio && fechaFin) {
            cargarRips();
        }
    }, [fechaInicio, fechaFin, filtroTipo]);

    const cargarRips = async () => {
        setLoading(true);
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.get('/rips', {
                params: {
                    uid: userdata.user_id,
                    fecha_inicio: fechaInicio,
                    fecha_fin: fechaFin,
                    tipo: filtroTipo
                }
            });
            setRips(response.data);
        } catch (error) {
            console.error('Error cargando RIPS:', error);
            alert('Error al cargar los registros RIPS');
        } finally {
            setLoading(false);
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO');
    };

    const formatearValor = (valor) => {
        if (!valor || valor === 0) return '-';
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const getTipoRegistro = (rips) => {
        const tipos = [];
        if (rips.consultas) tipos.push('Consulta');
        if (rips.procedimientos) tipos.push('Procedimiento');
        return tipos.join(' + ') || 'N/A';
    };

    const getEstadoBadge = (estado) => {
        switch (estado) {
            case 0:
                return <span className="badge badge-outline-secondary">Anulado</span>;
            case 1:
                return <span className="badge badge-outline-success">Generado</span>;
            case 2:
                return <span className="badge badge-outline-warning">Por convenio</span>;
            case 3:
                return <span className="badge badge-outline-info">Enviado</span>;
            case 4:
                return <span className="badge badge-outline-info">Enviado convenio</span>;
            default:
                return <span className="badge badge-outline-secondary">Desconocido</span>;
        }
    };

    const getTipoRips = (item) => {
        if (item.factura_id) {
            if (item.estado === 2 || item.estado === 4) {
                return 'convenio';
            }
            return 'fev';
        }
        return 'sin_fev';
    };

    const verDetalle = (item) => {
        setRipsSeleccionado({
            rips_id: item.id,
            factura_id: item.factura_id,
            tipo: getTipoRips(item),
            estado: item.estado
        });
        setShowModalInfo(true);
    };

    const handleDescargar = async (ripsId) => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));

            let endpoint;
            let fileName;

            if (ripsSeleccionado && (ripsSeleccionado.estado === 2 || ripsSeleccionado.estado === 4) && ripsSeleccionado.factura_id) {
                endpoint = `/rips/convenio/${ripsSeleccionado.factura_id}/descargar`;
                fileName = `rips_convenio_${ripsSeleccionado.factura_id}`;
            } else {
                endpoint = `/rips/${ripsId}/descargar`;
                fileName = `rips_${ripsId}`;
            }

            const response = await axios.get(endpoint, {
                params: { uid: userdata.user_id },
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentType = response.headers['content-type'];
            const finalFileName = contentType.includes('zip')
                ? `${fileName}.zip`
                : `${fileName}.json`;

            link.setAttribute('download', finalFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error Descargando RIPS:', error);
            alert('No Se Pudo Generar El Archivo RIPS. Por Favor, Intente Descargarlo Nuevamente');
        }
    };

    const handleEnviar = async (ripsId) => {
        try {
            const response = await axios.post(`/rips/${ripsId}/enviar`);

            if (response.data.success) {
                alert(`Los Archivos RIPS Se Han Enviado Y Procesado Correctamente\n\nEstado anterior: ${response.data.estado_anterior}\nEstado nuevo: ${response.data.estado_nuevo}`);
                setShowModalInfo(false);
                cargarRips();
            }
        } catch (error) {
            console.error('Error enviando RIPS:', error);
            alert('No Se Pudo Enviar El Archivo RIPS. Por Favor, Intente Enviarlo Nuevamente ' + (error.response?.data?.message || error.message));
        }
    };

    const handleCerrarModal = () => {
        setShowModalInfo(false);
        setRipsSeleccionado(null);
    };

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (hasPermission !== true) {
        return (
            <div className="hold-transition">
                <Loading />
            </div>
        );
    }

    return (
        <div className="hold-transition">
            <Header />
            <Aside activelink="indicators" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/indicadores">Indicadores</Link></li>
                                    <li className="breadcrumb-item active">RIPS</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-center">
                            <div className="col-sm-8">
                                <h1 className="m-0">
                                    <i className="fas fa-notes-medical text-secondary mr-2"></i>
                                    Listado de RIPS
                                </h1>
                            </div>
                            <div className="col-sm-4 text-sm-right">
                                <Link to="/indicadores" className="btn btn-outline-secondary btn-sm">
                                    <i className="fas fa-arrow-left mr-1"></i>
                                    Volver
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card report-fin-card mb-3">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-filter mr-2"></i>
                                    Filtros de búsqueda
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Fecha inicio</label>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                value={fechaInicio}
                                                onChange={(e) => setFechaInicio(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Fecha fin</label>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                value={fechaFin}
                                                onChange={(e) => setFechaFin(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Tipo de registro</label>
                                            <select
                                                className="form-control form-control-sm"
                                                value={filtroTipo}
                                                onChange={(e) => setFiltroTipo(e.target.value)}
                                            >
                                                <option value="">Todos</option>
                                                <option value="consulta">Consultas</option>
                                                <option value="procedimiento">Procedimientos</option>
                                                <option value="ambos">Consulta + procedimiento</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="d-block">&nbsp;</label>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm btn-block"
                                                onClick={cargarRips}
                                                disabled={loading}
                                            >
                                                <i className="fas fa-search mr-1"></i>
                                                Buscar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card report-fin-card">
                            <div className="card-header d-flex align-items-center flex-wrap">
                                <h3 className="card-title mb-0">
                                    <i className="fas fa-list mr-2"></i>
                                    Registros RIPS
                                </h3>
                                <div className="card-tools ml-auto mt-2 mt-sm-0">
                                    <span className="listado-rips-count-badge">
                                        {rips.length} {rips.length === 1 ? 'registro' : 'registros'}
                                    </span>
                                </div>
                            </div>
                            <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-secondary" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                        <p className="mt-3 mb-0 text-muted small">Cargando registros…</p>
                                    </div>
                                ) : (
                                    <table className="table table-bordered table-striped table-hover mb-0 report-fin-table">
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Tipo</th>
                                                <th>Paciente</th>
                                                <th>Profesional</th>
                                                <th>Factura</th>
                                                <th className="text-right">Valor</th>
                                                <th className="text-center">Estado</th>
                                                <th className="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rips.length === 0 ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-4 text-muted">
                                                        No se encontraron registros RIPS para el período seleccionado.
                                                    </td>
                                                </tr>
                                            ) : (
                                                rips.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>{formatearFecha(item.fecha)}</td>
                                                        <td>{getTipoRegistro(item)}</td>
                                                        <td>
                                                            <div className="listado-rips-paciente">
                                                                <strong>{item.paciente_nombre}</strong>
                                                                <div className="text-muted small">
                                                                    {item.paciente_tipo_doc} {item.paciente_numero_doc}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td><span className="small">{item.profesional_nombre}</span></td>
                                                        <td>
                                                            {item.factura_id ? (
                                                                <span className="badge badge-outline-success">
                                                                    {item.factura_prefijo}-{item.factura_numero}
                                                                </span>
                                                            ) : (
                                                                <span className="badge badge-outline-secondary">Sin factura</span>
                                                            )}
                                                        </td>
                                                        <td className="text-right">
                                                            <strong>{formatearValor(item.valor_rips)}</strong>
                                                        </td>
                                                        <td className="text-center">{getEstadoBadge(item.estado)}</td>
                                                        <td className="text-center text-nowrap">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary"
                                                                title="Ver detalle"
                                                                onClick={() => verDetalle(item)}
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </button>
                                                            {item.factura_id && (
                                                                <Link
                                                                    to={`/informacion-factura/${item.factura_id}`}
                                                                    className="btn btn-sm btn-outline-rips-slate ml-1"
                                                                    title="Ver factura"
                                                                >
                                                                    <i className="fas fa-file-invoice"></i>
                                                                </Link>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />

            {ripsSeleccionado && (
                <ModalRipsExito
                    show={showModalInfo}
                    onClose={handleCerrarModal}
                    ripsData={ripsSeleccionado}
                    onDescargar={handleDescargar}
                    onEnviar={handleEnviar}
                />
            )}
        </div>
    );
}

export default ListadoRips;
